import {all, takeEvery, put, call, select} from 'redux-saga/effects';
import actions from "./actions"
import {getCustomerConfiguration} from "../../services/customer_configuration.service";
import {ReducerType} from "../reducer.type";
import { ClientWorkspace } from '../client/client.type';
import { AxiosResponse } from 'axios';

const getWorkspace = (state: ReducerType) => state.client.owner.workspace;

export function* GET_CONFIGURATION(action: {payload: string, type: string}){
    try{
        const items: ClientWorkspace = yield select(getWorkspace);
        const response: AxiosResponse<any> = yield call(getCustomerConfiguration, items ? items.uuid : action.payload);
        if(response.data){
            yield put({
                type: actions.SET_CONFIGURATION,
                payload: response.data
            })
        }
    } catch (e) {
    }
}

export default function* RootSaga(){
    yield all([
        takeEvery(actions.GET_CONFIGURATION, GET_CONFIGURATION),
    ])
}